import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSpacer = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 60,
	viewBox: "0 0 20.0 60.0",
	...props,
	children: [/* @__PURE__ */ _jsx("ellipse", {
		cx: 10,
		cy: 10,
		rx: 10,
		ry: 10,
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	}), /* @__PURE__ */ _jsx("path", {
		d: "M 10.0 20.0 L 10.0 60.0",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	})]
});
export default SvgSpacer;
